import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";

// ##### Public ##### \\
import Homepage from "./pages/Public/Homepage";
import RestrictedRoute from "./components/Protected/RestrictedRoute";
import Storefront from "./pages/Storefront/Storefront";
// import Checkout from "./pages/Checkout/Checkout";
// import SingleCheckout from "./pages/Checkout/SingleCheckout";
// import PromotionalOffers from "./pages/Checkout/Offers";
import Error404 from "./pages/Error/Error404";
import MaintenancePage from "./pages/Maintenance/Maintenance";

import CheckoutForm_v2_1 from "./pages/version/2.1/Checkout/CheckoutForm";
import CancelSubscription from "./pages/Public/CancelSubscription";

import AuthGate from "./components/Protected/AuthGate";

import CheckoutPage from "./pages/version/3/Checkout/CheckoutPage";

// import TestCheckout from "./pages/version/2/Checkout/TestCheckout";
// const PaymentSuccessTest = lazy(
//   () => import("./pages/version/2/PaymentStatus/PaymentSuccessTest"),
// );
// const PaymentSuccess = lazy(() => import("./pages/Checkout/PaymentSuccess"));
// const Receipt = lazy(() => import("./pages/Checkout/Receipt"));

// ##### Logged in ##### \\
const Login = lazy(() => import("./pages/Public/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));

// Stores
const AddStoreAccount = lazy(
  () => import("./pages/StoreAccounts/AddStoreAccount"),
);
const EditStoreAccount = lazy(
  () => import("./pages/StoreAccounts/EditStoreAccount"),
);
const StoreAccounts = lazy(() => import("./pages/StoreAccounts/StoreAccounts"));

// Admins
const Admins = lazy(() => import("./pages/Admins/Admins"));
const AddAdmin = lazy(() => import("./pages/Admins/AddAdmin"));
const EditAdmin = lazy(() => import("./pages/Admins/EditAdmin"));

// My Profile
const MyAccount = lazy(() => import("./pages/me/MyAccount"));

// Products
const Products = lazy(() => import("./pages/Products/Products"));
const AddProduct = lazy(() => import("./pages/Products/AddProduct"));
const Product = lazy(() => import("./pages/Product/Product"));

// Price plans of the team
const Prices = lazy(() => import("./pages/Prices/Prices"));

// Price plans of product
const Price = lazy(() => import("./pages/Product/Price"));
const AddPrice = lazy(() => import("./pages/Product/AddPrice"));
const EditPrice = lazy(() => import("./pages/Product/EditPrice"));
const PriceSettings = lazy(() => import("./pages/Product/PriceSettings"));
const EditPriceConversions = lazy(
  () => import("./pages/Product/EditPriceConversions"),
);
const CheckoutContentForm = lazy(
  () => import("./pages/Price/CheckoutContentForm"),
);

// Reminder Emails
const ReminderEmailsTable = lazy(
  () => import("./pages/ReminderEmails/ReminderEmailsTable"),
);
const AddReminderEmail = lazy(
  () => import("./pages/ReminderEmails/AddReminderEmail"),
);
const UpdateReminderEmail = lazy(
  () => import("./pages/ReminderEmails/UpdateReminderEmail"),
);

// Membership groups
const MembershipGroupsTable = lazy(
  () => import("./pages/MembershipGroups/MembershipGroupsTable"),
);
const AddMembershipGroup = lazy(
  () => import("./pages/MembershipGroups/AddMembershipGroup"),
);
const UpdateMembershipGroup = lazy(
  () => import("./pages/MembershipGroups/UpdateMembershipGroup"),
);

const EditPaymentGatewayOfPricePlan = lazy(
  () => import("./pages/Product/EditPaymentGatewayOfPricePlan"),
);
const EditRedirectOfPricePlan = lazy(
  () => import("./pages/Product/EditRedirectOfPricePlan"),
);
const EditPriceMembershipGroup = lazy(
  () => import("./pages/Product/EditPriceMembershipGroup"),
);

// Everflow offers of price plans
const AllEverflowOffersOfPricePlan = lazy(
  () => import("./pages/Product/AllEverflowOffersOfPricePlan"),
);
const AddEverflowOfferOfPricePlan = lazy(
  () => import("./pages/Product/AddEverflowOfferOfPricePlan"),
);
const EditEverflowOfferOfPricePlan = lazy(
  () => import("./pages/Product/EditEverflowOfferOfPricePlan"),
);

// Coupons of the team
const AllCoupons = lazy(() => import("./pages/Coupons/Coupons"));

// Coupons of the price plans
const Coupons = lazy(() => import("./pages/Coupon/Coupons"));
const AddCoupon = lazy(() => import("./pages/Coupon/AddCoupon"));
const Coupon = lazy(() => import("./pages/Coupon/Coupon"));

// // All promos of the team
// const AllPromos = lazy(() => import("./pages/Promos/Promos"));

// // Promos of the price plans
// const Promos = lazy(() => import("./pages/Promo/Promos"));
// const AddPromo = lazy(() => import("./pages/Promo/AddPromo"));
// const EditPromo = lazy(() => import("./pages/Promo/EditPromo"));

// // Discount stacks
// const DiscountStacks = lazy(() =>
//   import("./pages/DiscountStacks/DiscountStacks")
// );

// Discord
const DiscordSettings = lazy(
  () => import("./pages/DiscordRoles/DiscordRolesSetting"),
);
const DiscordRoles = lazy(() => import("./pages/DiscordRoles/DiscordRoles"));
const DiscordRole = lazy(() => import("./pages/DiscordRole/DiscordRole"));

// Discord
const Imports = lazy(() => import("./pages/Imports/Imports"));

// Webhooks
// const Webhooks = lazy(() => import("./pages/Webhooks/Webhooks"));
// const Webhook = lazy(() => import("./pages/Webhook/Webhook"));
// const AddWebhook = lazy(() => import("./pages/Webhook/AddWebhook"));

// Students
const Students = lazy(() => import("./pages/Students/Students"));
const AddStudent = lazy(() => import("./pages/Students/AddStudent"));
const Student = lazy(() => import("./pages/Student/Student"));
const StudentOrders = lazy(() => import("./pages/Student/StudentOrders"));
const EmailEngagements = lazy(() => import("./pages/Student/EmailEngagements"));
const LogsOfEmailEngagement = lazy(
  () => import("./pages/Student/LogsOfEmailEngagement"),
);

// Subscriptions of students
const Subscriptions = lazy(() => import("./pages/Student/Subscriptions"));

// Orders of students
const Orders = lazy(() => import("./pages/Orders/Orders"));
const AutoRenewalItems = lazy(
  () => import("./pages/version/2/Items/AutoRenewalItems"),
);

// Orders of student
// const OrderInfo = lazy(() => import("./pages/Student/OrderInfo"));
const TransferOrder = lazy(() => import("./pages/Student/TransferOrder"));
const AddOrder = lazy(() => import("./pages/Student/AddOrder"));

// Order items of student
// const ItemInfo = lazy(() => import("./pages/Item/ItemInfo"));
const ChangeOrderItem = lazy(() => import("./pages/Student/ChangeOrderItem"));
// const RefundOrderItem = lazy(() => import("./pages/Student/RefundOrderItem"));
const CancelOrderItem = lazy(() => import("./pages/Student/CancelOrderItem"));

// Reports
// const ProfitabilityReports = lazy(() =>
//   import("./pages/Report/ProfitabilityReports")
// );
// const SalesVolumeReports = lazy(() =>
//   import("./pages/Report/SalesVolumeReports")
// );

// Settings
const Settings = lazy(() => import("./pages/Settings/Settings"));
const AllPaymentGateways = lazy(
  () => import("./pages/Settings/PaymentProviders/AllPaymentGateways"),
);
const AddPaymentGateway = lazy(
  () => import("./pages/Settings/PaymentProviders/AddPaymentGateway"),
);
const EditPaymentGateway = lazy(
  () => import("./pages/Settings/PaymentProviders/EditPaymentGateway"),
);

const HubSpotProperties = lazy(
  () => import("./pages/Settings/HubSpotProperties"),
);

const AllTaxes = lazy(() => import("./pages/Taxes/AllTaxes"));
const AddTax = lazy(() => import("./pages/Taxes/AddTax"));
const EditTax = lazy(() => import("./pages/Taxes/EditTax"));

const AllDomains = lazy(() => import("./pages/Domains/AllDomains"));
const AddDomain = lazy(() => import("./pages/Domains/AddDomain"));
const EditDomain = lazy(() => import("./pages/Domains/EditDomain"));

const AllScripts = lazy(() => import("./pages/Scripts/AllScripts"));
const AddScript = lazy(() => import("./pages/Scripts/AddScript"));
const EditScript = lazy(() => import("./pages/Scripts/EditScript"));

const AllSupports = lazy(() => import("./pages/Supports/AllSupports"));
const AddSupport = lazy(() => import("./pages/Supports/AddSupport"));
const EditSupport = lazy(() => import("./pages/Supports/EditSupport"));

// PrivateApps
const PrivateApps = lazy(() => import("./pages/PrivateApps/PrivateApps"));
const EditPrivateApp = lazy(() => import("./pages/PrivateApp/EditPrivateApp"));
const AddPrivateApp = lazy(() => import("./pages/PrivateApp/AddPrivateApp"));

// Automations
const Automation = lazy(() => import("./pages/Automation/Automation"));
const AddAutomation = lazy(() => import("./pages/Automation/AddAutomation"));

const EditAutomation = lazy(() => import("./pages/Automation/EditAutomation"));

// ##### Version 2 ##### //
const PaymentSuccessV2 = lazy(
  () => import("./pages/version/2/PaymentStatus/PaymentSuccess"),
);

const ReceiptV2 = lazy(() => import("./pages/version/2/Checkout/Receipt"));

// Order and order items
const OrderInfoV2 = lazy(() => import("./pages/version/2/Student/OrderInfo"));
const RefundOrderItemV2 = lazy(
  () => import("./pages/version/2/Student/RefundOrderItem"),
);
const ItemInfoV2 = lazy(() => import("./pages/version/2/Item/ItemInfo"));

// Webhooks
const WebhooksV2 = lazy(() => import("./pages/version/2/Webhooks/Webhooks"));
const EditWebhookV2 = lazy(
  () => import("./pages/version/2/Webhook/EditWebhook"),
);
const AddWebhookV2 = lazy(() => import("./pages/version/2/Webhook/AddWebhook"));

// Announcements
const Announcements = lazy(() => import("./pages/Announcements/Announcements"));
const EditAnnouncement = lazy(
  () => import("./pages/Announcement/EditAnnouncement"),
);
const AddAnnouncement = lazy(
  () => import("./pages/Announcement/AddAnnouncement"),
);

// Reports
const ProfitabilityReportsV2 = lazy(
  () => import("./pages/version/2/Reports/ProfitabilityReports"),
);
const SalesVolumeReportsV2 = lazy(
  () => import("./pages/version/2/Reports/SalesVolumeReports"),
);
const ActiveCancelledRateReportsV2 = lazy(
  () => import("./pages/version/2/Reports/ActiveCancelledRateReports"),
);
const AutoRenewalRateReportsV2 = lazy(
  () => import("./pages/version/2/Reports/AutoRenewalRateReports"),
);

function App() {
  const isUnderMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === "true";

  return (
    <Suspense fallback={<div></div>}>
      <Routes>
        {isUnderMaintenance ? (
          <Route path='*' element={<MaintenancePage />} />
        ) : (
          <>
            <Route path='/' element={<Homepage />} />

            <Route path='/stores/:store'>
              <Route index element={<Storefront />} />
              {/* <Route path='checkout' element={<Checkout />} /> */}
              {/* <Route path='plans/:price_slug' element={<SingleCheckout />} /> */}
              {/* <Route path='success' element={<PaymentSuccess />} /> */}

              <Route path='plans/:price_slug' element={<CheckoutForm_v2_1 />} />
              <Route path='success' element={<PaymentSuccessV2 />} />

              <Route
                path='plans/:price_slug/temp-preview'
                element={<CheckoutPage />}
              />

              {/* <Route path='offers' element={<PromotionalOffers />} /> */}
              <Route path='receipt' element={<ReceiptV2 />} />

              {/* Cancel subscription */}
              <Route
                path='subscriptions/cancel'
                element={<CancelSubscription />}
              />
            </Route>

            <Route path='/login' element={<Login />} />

            {/* Owners && Admins only */}
            {/* We seperated into AuthGate and RestrictedRoute because they have their own layout designs */}
            {/* The layout will jump from one to another if we don't split accordingly */}
            <Route element={<AuthGate />}>
              <Route path='/dashboards' element={<Dashboard />} />

              <Route path='/store-accounts'>
                <Route index path='' element={<StoreAccounts />} />
                <Route path='new' element={<AddStoreAccount />} />
                <Route path=':store_id' element={<EditStoreAccount />} />
              </Route>

              <Route path='/admins'>
                <Route index path='' element={<Admins />} />
                <Route path='new' element={<AddAdmin />} />
                <Route path=':admin_id' element={<EditAdmin />} />
              </Route>

              <Route path='/my-account' element={<MyAccount />} />
            </Route>

            <Route element={<RestrictedRoute />}>
              {/* Teams */}
              <Route path='/teams/:team_id'>
                {/* Students */}
                <Route path='students' element={<Students />} />
                <Route path='students/new' element={<AddStudent />} />
                <Route path='students/:student_id' element={<Student />} />

                {/* Orders of student */}
                {/* All orders of the students */}
                <Route
                  path='students/:student_id/orders'
                  element={<StudentOrders />}
                />
                <Route
                  path='students/:student_id/orders/new'
                  element={<AddOrder />}
                />
                {/* <Route
                  path='students/:student_id/orders/:order_id'
                  element={<OrderInfo />}
                /> */}
                <Route
                  path='students/:student_id/orders/:order_id'
                  element={<OrderInfoV2 />}
                />

                <Route
                  path='students/:student_id/orders/:order_id/transfer'
                  element={<TransferOrder />}
                />

                <Route
                  path='students/:student_id/subscriptions'
                  element={<Subscriptions />}
                />

                {/* Email Contents sent to students */}
                <Route
                  path='students/:student_id/email-engagements'
                  element={<EmailEngagements />}
                />
                <Route
                  path='students/:student_id/email-engagements/:email_engagement_id/logs'
                  element={<LogsOfEmailEngagement />}
                />

                {/* Order items of student */}
                {/* <Route
                  path='students/:student_id/orders/:order_id/items/:item_id'
                  element={<ItemInfo />}
                /> */}
                <Route
                  path='students/:student_id/orders/:order_id/items/:item_id'
                  element={<ItemInfoV2 />}
                />

                <Route
                  path='students/:student_id/orders/:order_id/items/:item_id/change'
                  element={<ChangeOrderItem />}
                />
                {/* <Route
                  path='students/:student_id/orders/:order_id/items/:item_id/refund'
                  element={<RefundOrderItem />}
                /> */}
                <Route
                  path='students/:student_id/orders/:order_id/items/:item_id/refund'
                  element={<RefundOrderItemV2 />}
                />

                <Route
                  path='students/:student_id/orders/:order_id/items/:item_id/cancel'
                  element={<CancelOrderItem />}
                />

                {/* All orders of the team */}
                <Route path='orders' element={<Orders />} />
                <Route
                  path='auto-renewal-lists'
                  element={<AutoRenewalItems />}
                />

                {/* All price plans of the team */}
                <Route path='prices' element={<Prices />} />

                {/* Reminder emails */}
                <Route
                  path='reminder-emails'
                  element={<ReminderEmailsTable />}
                />
                <Route
                  path='reminder-emails/new'
                  element={<AddReminderEmail />}
                />
                <Route
                  path='reminder-emails/:reminder_email_id'
                  element={<UpdateReminderEmail />}
                />

                <Route
                  path='membership-groups'
                  element={<MembershipGroupsTable />}
                />
                <Route
                  path='membership-groups/new'
                  element={<AddMembershipGroup />}
                />
                <Route
                  path='membership-groups/:membership_group_id'
                  element={<UpdateMembershipGroup />}
                />

                {/* All coupons of the team */}
                <Route path='coupons' element={<AllCoupons />} />

                {/* All promotions of the team */}
                {/* <Route path='promos' element={<AllPromos />} /> */}

                {/* All coupons of the team */}
                {/* <Route path='discount-stacks' element={<DiscountStacks />} /> */}

                {/* Products */}
                <Route path='products' element={<Products />} />
                <Route path='products/new' element={<AddProduct />} />
                <Route path='products/:product_id' element={<Product />} />

                {/* Price plans of products */}
                <Route path='products/:product_id/prices' element={<Price />} />
                <Route
                  path='products/:product_id/prices/new'
                  element={<AddPrice />}
                />
                <Route
                  path='products/:product_id/prices/:price_id'
                  element={<EditPrice />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/settings'
                  element={<PriceSettings />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/payment-gateways'
                  element={<EditPaymentGatewayOfPricePlan />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/tracking-snippets'
                  element={<EditPriceConversions />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/redirects'
                  element={<EditRedirectOfPricePlan />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/membership-groups'
                  element={<EditPriceMembershipGroup />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/everflow-offers'
                  element={<AllEverflowOffersOfPricePlan />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/everflow-offers/new'
                  element={<AddEverflowOfferOfPricePlan />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/everflow-offers/:everflow_offer_id'
                  element={<EditEverflowOfferOfPricePlan />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/customise-checkout-page'
                  element={<CheckoutContentForm />}
                />

                {/* Coupon */}
                {/* All coupons of the price plans */}
                <Route
                  path='products/:product_id/prices/:price_id/coupons'
                  element={<Coupons />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/coupons/new'
                  element={<AddCoupon />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/coupons/:coupon_id'
                  element={<Coupon />}
                />

                {/* Promos */}
                {/* All promos of the price plans */}
                {/* <Route
                  path='products/:product_id/prices/:price_id/promos'
                  element={<Promos />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/promos/new'
                  element={<AddPromo />}
                />
                <Route
                  path='products/:product_id/prices/:price_id/promos/:promo_id'
                  element={<EditPromo />}
                /> */}

                {/* Reports */}
                {/* <Route path='reports' element={<ProfitabilityReports />} />
                <Route path='reports/plans' element={<SalesVolumeReports />} /> */}

                {/* Reports */}
                <Route path='reports' element={<ProfitabilityReportsV2 />} />
                <Route
                  path='reports/sales-volume'
                  element={<SalesVolumeReportsV2 />}
                />
                <Route
                  path='reports/active-cancelled-rate'
                  element={<ActiveCancelledRateReportsV2 />}
                />
                <Route
                  path='reports/auto-renewal-rate'
                  element={<AutoRenewalRateReportsV2 />}
                />

                {/* Settings */}
                <Route path='settings' element={<Settings />} />
                <Route
                  path='settings/payment-gateways'
                  element={<AllPaymentGateways />}
                />
                <Route
                  path='settings/payment-gateways/new'
                  element={<AddPaymentGateway />}
                />
                <Route
                  path='settings/payment-gateways/:payment_account_id'
                  element={<EditPaymentGateway />}
                />

                {/* Taxes list */}
                <Route path='settings/taxes' element={<AllTaxes />} />
                <Route path='settings/taxes/new' element={<AddTax />} />
                <Route
                  path='settings/taxes/:ppay_tax_id'
                  element={<EditTax />}
                />

                {/* PrivateApps */}
                <Route path='settings/private-apps' element={<PrivateApps />} />
                <Route
                  path='settings/private-apps/:app_id'
                  element={<EditPrivateApp />}
                />
                <Route
                  path='settings/private-apps/new'
                  element={<AddPrivateApp />}
                />

                {/* SSO Domain Lists */}
                <Route path='settings/domains' element={<AllDomains />} />
                <Route path='settings/domains/new' element={<AddDomain />} />
                <Route
                  path='settings/domains/:ppay_domain_id'
                  element={<EditDomain />}
                />

                {/* SSO Domain Lists */}
                <Route
                  path='settings/tracking-codes'
                  element={<AllScripts />}
                />
                <Route
                  path='settings/tracking-codes/new'
                  element={<AddScript />}
                />
                <Route
                  path='settings/tracking-codes/:ppay_script_id'
                  element={<EditScript />}
                />

                {/* Email Support Lists */}
                <Route path='settings/supports' element={<AllSupports />} />
                <Route path='settings/supports/new' element={<AddSupport />} />
                <Route
                  path='settings/supports/:ppay_support_id'
                  element={<EditSupport />}
                />

                {/* HubSpot Properties */}
                <Route
                  path='settings/hubspot'
                  element={<HubSpotProperties />}
                />

                {/* Discord Roles */}
                <Route path='discord' element={<DiscordSettings />} />
                <Route path='discord/roles' element={<DiscordRoles />} />
                <Route
                  path='discord/roles/:discord_role_id'
                  element={<DiscordRole />}
                />

                {/* Imports */}
                <Route path='imports' element={<Imports />} />

                {/* Webhooks */}
                <Route path='webhooks' element={<WebhooksV2 />} />
                <Route
                  path='webhooks/:webhook_id'
                  element={<EditWebhookV2 />}
                />
                <Route path='webhooks/new' element={<AddWebhookV2 />} />

                {/* Announcements */}
                <Route path='announcements' element={<Announcements />} />
                <Route
                  path='announcements/:notification_id'
                  element={<EditAnnouncement />}
                />
                <Route path='announcements/new' element={<AddAnnouncement />} />

                {/* Automations */}
                <Route path='automations' element={<Automation />} />
                <Route path='automations/new' element={<AddAutomation />} />
                <Route
                  path='automations/:automation_id'
                  element={<EditAutomation />}
                />
              </Route>

              {/* <Route path='v2/teams/:team_id'>
                
              </Route> */}
            </Route>

            <Route path='*' element={<Error404 />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
}

export default App;
